import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Input } from "../components/commonComponent/FormInput";
import { useAuth } from "../context/AuthContext";
import { useFormContext } from "../context/FormContext";
import { LOADING, LOGIN } from "../constants/SiteConstants";
import Loader from "../components/commonComponent/Loader";

const LoginForm = () => {
  const methods = useFormContext();
  const { login } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const success = await login(data.email, data.password);
      if (success) {
        toast.success("Login successful", {
          autoClose: 1000,
        });
        navigate("/home");
      } else {
        toast.error("Invalid email or password", {
          autoClose: 1000,
        });
      }
    } catch (error) {
      toast.error("An error occurred. Please try again.", {
        autoClose: 1000,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <form
      className="w-full space-y-4 mt-5"
      onSubmit={methods.handleSubmit(onSubmit)}
    >
      <Input
        label={
          <span className="mb-2 block text-gray-700 font-medium">Email</span>
        }
        controlProp={{ name: "email", control: methods.control }}
        placeholder="Enter your email address"
        type="email"
      />
      <Input
        label={
          <span className="mb-2 block text-gray-700 font-medium">Password</span>
        }
        controlProp={{ name: "password", control: methods.control }}
        placeholder="Enter your password"
        type="password"
      />
      <button
        className={`w-full bg-blue-600 text-white py-3 rounded-lg font-semibold hover:bg-blue-700 transition duration-300 ${
          loading ? "opacity-50 cursor-not-allowed" : ""
        }`}
        type="submit"
        disabled={loading}
      >
        {loading ? (
          <Loader className="h-full flex justify-center items-center" insideClasses="w-5 h-5 border-2" />
        ) : (
          "Login"
        )}
      </button>

      {/* <div className="text-center mt-4">
        <span className="text-sm text-gray-600">
          Don’t have an account?{" "}
          <Link to="/register" className="text-blue-600 hover:underline">
            Create Account
          </Link>
        </span>
      </div> */}
    </form>
  );
};

export default LoginForm;
